import { useEffect, useState } from 'react';
import {
  FOLLOW_ACTIONS,
  FOLLOWING_STATUS
} from 'constants/follows/following-constants';

export const useCtaAction = (friend) => {
  const { approveFollowers, followingStatus } = friend;
  const [cta, setCta] = useState(FOLLOW_ACTIONS.follow);

  useEffect(() => {
    if (followingStatus === FOLLOWING_STATUS.pending) {
      setCta(FOLLOW_ACTIONS.followRequested);
    } else if (followingStatus === FOLLOWING_STATUS.following) {
      setCta(FOLLOW_ACTIONS.following);
    } else {
      setCta(
        approveFollowers
          ? FOLLOW_ACTIONS.requestToFollow
          : FOLLOW_ACTIONS.follow
      );
    }
  }, [approveFollowers, followingStatus]);

  return cta;
};

export default useCtaAction;
